export default "__VITE_ASSET__Yq4QKJPm__"